"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "S3FileModel", {
    enumerable: true,
    get: function() {
        return S3FileModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const S3FileModel = _zod.z.object({
    _id: _zod.z.union([
        _zod.z.string(),
        _zod.z.instanceof(_bson.ObjectId)
    ]),
    avScanDate: _zod.z.date().optional(),
    avScanDateFinished: _zod.z.date().optional(),
    avScanDateStarted: _zod.z.date().optional(),
    clean: _zod.z.boolean().optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    content_type: _zod.z.string().optional(),
    doc_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    expires: _zod.z.date().optional(),
    filename: _zod.z.string(),
    length: _zod.z.number().optional(),
    md5: _zod.z.string().optional(),
    owner: _zod.z.instanceof(_bson.ObjectId).optional(),
    page: _zod.z.number().optional(),
    pending: _zod.z.boolean().optional(),
    signature_request: _zod.z.instanceof(_bson.ObjectId).optional(),
    signers: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    tags: _zod.z.array(_zod.z.string()).optional(),
    temporary: _zod.z.boolean().optional(),
    token: _zod.z.string().optional(),
    uploadDate: _zod.z.date().optional(),
    uploader: _zod.z.instanceof(_bson.ObjectId).optional(),
    vis_to_emp: _zod.z.boolean().optional(),
    vis_to_everyone: _zod.z.boolean().optional(),
    vis_to_man: _zod.z.boolean().optional(),
    allow_ai_retrieval: _zod.z.boolean().optional()
});
